import React from 'react';

import { computed } from 'mobx';
import { observer } from 'mobx-react';

interface IProps {
  className?: string;
  imageUrl?: string;
}

@observer
class Image extends React.Component<IProps> {
  render() {
    if (!this.show) {
      return null;
    }

    const { className, imageUrl } = this.props;
    return (
      <div
        className={className}
        style={{
          background: imageUrl
        }}
      />
    );
  }

  @computed
  private get show(): boolean {
    const { imageUrl } = this.props;
    return !!imageUrl;
  }
}

export default Image;
